import React from 'react'
import { FormDataConsumer } from 'react-admin'
import {
  getSelectionChoices,
  resetFormItemName,
} from 'resources/operations/events/utils'
import {
  FormDataConsumerProps,
  WithIdAndName,
  WithQuantity,
} from 'types/common'
import LocalizedAutocomplete from 'ui-shared/LocalizedFields/LocalizedAutocomplete'
import EventProductQuantityInput from './EventProductQuantityInput'

export type EventSubSelectionInputContentProps = {
  label: string
  choices?: WithIdAndName[]
  hideQuantity?: boolean
  disableInputs?: boolean
}

const EventSubSelectionInputContent: React.FC<
  EventSubSelectionInputContentProps
> = ({ label, choices = [], hideQuantity, disableInputs = false, ...rest }) => {
  return (
    <FormDataConsumer {...rest}>
      {({
        scopedFormData,
        getSource,
      }: FormDataConsumerProps<unknown, WithIdAndName & WithQuantity>) => (
        <div style={{ display: 'flex', width: '100%' }}>
          {!hideQuantity && (
            <EventProductQuantityInput
              getSource={getSource}
              disabled={disableInputs}
            />
          )}
          <LocalizedAutocomplete
            source={getSource!('id')}
            fullWidth
            label={label}
            choices={getSelectionChoices(scopedFormData, choices)}
            disabled={disableInputs}
            onSelect={resetFormItemName(scopedFormData)}
          />
        </div>
      )}
    </FormDataConsumer>
  )
}

export default EventSubSelectionInputContent
